export default function Franqueado() {
  return <h1>Franqueado</h1>;
}
